import { render, staticRenderFns } from "./ReportRecommend.vue?vue&type=template&id=a6c386a8"
import script from "./ReportRecommend.vue?vue&type=script&lang=js"
export * from "./ReportRecommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports